export const ADD_FILE = "ADD_FILE";
export const ADD_QUERY = "ADD_QUERY";
export const ADD_EMAIL = "ADD_EMAIL";
export const DELETE_FILE = "DELETE_FILE";

export interface FileData {
  id: string;
  name: string;
  domain: string;
  subdomain: string;
  version: string;
  pages: number;
  uploadDate: Date;
}
export interface QueryData {
  query_hash: string;
  query: string;
  response: string;
}

export interface EmailData {
  query_hash: string;
  query: string;
  response: string;
  email: string;
  mobile_num: string;
}

export interface AddFileAction {
  type: typeof ADD_FILE;
  payload: FileData;
}
export interface AddQueryAction {
  type: typeof ADD_QUERY;
  payload: QueryData;
}
export interface AddEmailAction {
  type: typeof ADD_EMAIL;
  payload: EmailData;
}

export interface DeleteFileAction {
  type: typeof DELETE_FILE;
  payload: string;
}

export const addFile = (files: FileData[]) => ({
  type: ADD_FILE,
  payload: files,
});
export const addQuery = (files: FileData[]) => ({
  type: ADD_QUERY,
  payload: files,
});
export const addEmail = (files: FileData[]) => ({
  type: ADD_EMAIL,
  payload: files,
});

export const deleteFile = (fileId: string): DeleteFileAction => ({
  type: DELETE_FILE,
  payload: fileId,
});

export type FileActionTypes =
  | AddFileAction
  | DeleteFileAction
  | AddQueryAction
  | AddEmailAction;
